
<template>
	<div class="fail-message" >
		<section>
			<h3>{{title}}</h3>
			<slot></slot>
		</section>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: 'FailMessage',
		props: {
			title: {type:String, default: "Something Went Wrong"},
		},
	};
</script>

<style scoped>
	.fail-message{
		background-color: #FFE1E1;
		border: 1px solid #C83F3F;
		padding:20px;
		border-radius: 3px;
		margin-top:10px;
		margin: 10px;
		text-align: left;
	}
	.fail-message h3{
		margin-top: 0;
	}
	.fail-message ul {
		margin: auto;
		text-align: left;
		list-style-position: inside;
	}
	.fail-message li {
		width: auto;
		margin:10px auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/FailMessage.vue